
export const featureGetHumanDatesForGivenPeriod = (dateFrom: string, dateTo: string): { id: string, name: string }[] => {
    const dateFromObject = new Date(dateFrom);
    const dateToObject = new Date(dateTo);
    const dateFromYear = dateFromObject.getFullYear();
    const dateFromMonth = dateFromObject.getMonth();
    const dateToYear = dateToObject.getFullYear();
    const dateToMonth = dateToObject.getMonth();
    const result = [];
    for (let year = dateFromYear; year <= dateToYear; year++) {
        const monthStart = (year === dateFromYear) ? dateFromMonth : 0;
        const monthEnd = (year === dateToYear) ? dateToMonth : 11;
        for (let month = monthStart; month <= monthEnd; month++) {
            result.push({
                id: year + '-' + (month + 1).toString().padStart(2, '0'),
                name: getMonthName(month) + ' ' + year,
            });
        }
    }
    return result;

    function getMonthName(month: number): string {
        const months = [
            'styczeń',
            'luty',
            'marzec',
            'kwiecień',
            'maj',
            'czerwiec',
            'lipiec',
            'sierpień',
            'wrzesień',
            'październik',
            'listopad',
            'grudzień',
        ];
        return months[month];
    }
}
